<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Sổ liên lạc</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          hide-details
          value="view-contactBook-group"
          :label="'Cho phép ' + roleName + ' thiết lập sổ liên lạc'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- danh sách -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-contactBook-list"
          :label="'Cho phép ' + roleName + ' xem danh sách sổ liên lạc'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="config-contactBook"
          :label="'Cho phép ' + roleName + ' cài đặt sổ liên lạc'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-contactBook"
          :label="'Cho phép ' + roleName + ' xóa sổ liên lạc'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="lock-contactBook"
          :label="'Cho phép ' + roleName + ' khóa sổ liên lạc'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- gửi tin đột xuất -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="send-noti-immediately"
          :label="'Cho phép ' + roleName + ' gửi tin nhắn đột xuất'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- gửi tin tự động -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="send-noti-daily"
          :label="'Cho phép ' + roleName + ' gửi tin nhắn tự động'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- lịch sử -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-noti-history"
          :label="'Cho phép ' + roleName + ' xem lịch sử gửi tin'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="resend-fail-noti"
          :label="'Cho phép ' + roleName + ' xử lý tin nhắn lỗi'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
